export const lang = {
  home: 'Home',
  htmltitle: 'GMIC Live Pro',
  mainstage: 'Thought Leader',
  stage2: 'Digital Marketing Summit',
  speakers: 'Guests',
  agenda: 'Agenda',
  search: 'Discover',
  status1: 'Start',
  status2: 'End',
  status3: 'Now Live',
  zddw: 'Advised by',
  hzhb: 'Partners',
  pphzhb: 'Brand Partners',
  nrhzhb: 'Content Partners',
  fgw: 'Beijing Municipal Commission of Development and Reform',
  zgc: 'Zhongguancun Science City',
  djdzk: 'Trending',
  jbgnl: 'Talk to Our Guests',
  dh: 'Dialogue',
  dlzc: 'Log in/Register',
  zcxx: 'Registration Info',
  true: '(Please provide real information.)',
  hy: 'Your Industry',
  three: '(*Choose up to three)',
  three2: 'Choose up to three',
  tg: 'Skip',
  ljzc: 'Register',
  tj: 'Submit',
  one: 'Please select at least one of your industries.',
  error: 'Request failed, please try again later.',
  notfull: 'Incomplete registration information!',
  name: 'Full Name',
  company: 'Company',
  title: 'Job Title/Position',
  tel: 'Phone Number',
  email: 'Email address',
  ts: 'Notice',
  qr: 'Confirm',
  unstart: 'Stay tuned for our live stream. ',
  end: 'Our live stream is over.',
  kbsj: 'Start Time',
  djhzhb: 'Top Partners',
  mt: 'Medias'
}



// WEBPACK FOOTER //
// ./src/common/lang/en.js